import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { fireCampaignUtmViewed } from '~/posthogs/events/Campaigns';

const SESSION_KEY = 'campaign_utm_tracked';

export const useCampaignTracker = () => {
  const { search } = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) {
      return;
    }

    const params = new URLSearchParams(search);
    const source = params.get('utm_source');
    const campaign = params.get('utm_campaign');
    const medium = params.get('utm_medium');

    if (!source || !campaign || !medium) {
      return;
    }

    fireCampaignUtmViewed({ source, campaign, medium });
    sessionStorage.setItem(SESSION_KEY, 'true');
  }, []);
};
